import { datadogRum } from '@datadog/browser-rum'

/**
 * True for errors that carry a 4xx status: a missing page, an expired token, a bad request.
 * Those are expected outcomes and are neither logged nor reported to RUM (FE-7316).
 */
export function isClientError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false
  }
  const status = 'statusCode' in error ? error.statusCode : 'status' in error ? error.status : undefined
  return typeof status === 'number' && status >= 400 && status < 500
}

export function handleError(
  error: unknown,
  message?: string,
  throwError = true,
) {
  if (isClientError(error)) {
    if (throwError) {
      throw error
    }
    return
  }

  if (!message) {
    if (typeof error === 'string') {
      message = error
    } else if (error instanceof Error) {
      message = error.message
    } else {
      message = 'Something went wrong'
    }
  }

  try {
    const data =
      !!error && typeof error === 'object' && 'data' in error && error.data
    datadogRum.addError(error, {
      message,
      ...(data ?? {}),
      thrown: String(throwError),
    })
  } catch (e) {
    console.warn(e)
  }

  console.error(error)
  if (throwError) {
    throw error
  }
}
